import { useTopicsOptions } from "api/hooks";
import { topicgroupsApi } from "api/topicgroups/topicgroupsApi";
import { routes } from "consts";
import React from "react";
import { useNavigate } from "react-router-dom";
import { TopicGroupForm, TopicGroupFormValues } from "./TopicGroupForm/TopicGroupForm";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { PaziaLoader } from "components/atoms";
import { timeToMinutes } from "utils";
import { PageMain } from "components/molecules";
import { useToaster } from "utils";

export const TopicGroupAddPage = (): JSX.Element | null => {
  const navigate = useNavigate();
  const { loading, options } = useTopicsOptions(true);
  const { showSuccess, showError } = useToaster();

  const onSubmit = async (data: TopicGroupFormValues) => {
    try {
      const { name, groupTime, topics } = data;
      await topicgroupsApi.create({
        name,
        groupTime: timeToMinutes(groupTime) || undefined,
        courseGroupIds: data.courseGroupIds?.filter(Boolean).map((x) => +x!) ?? [],
        topics: topics.map((x) => ({ id: x.id!, time: x.time ?? 0 })),
      });
      showSuccess("Grupa tematów została dodana");
      navigate(routes.TOPICS_GROUPS);
    } catch (e) {
      console.error(e);
      showError("Nie udało się dodać grupy tematów");
    }
  };

  if (loading || !options) return <PaziaLoader position="center" />;

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[{ title: "Grupy tematów", path: routes.TOPICS_GROUPS }, { title: "Tworzenie nowej grupy" }]}
        headerText="Dodaj nową grupę"
      />
      <TopicGroupForm onSubmit={onSubmit} topicOptions={options} />
    </PageMain>
  );
};
